<div class="button-container">
  <button (click)="openNewPartnerDialog()"
          color="accent"
          id="btn-add-ttd-partner"
          mat-raised-button
          matTooltip="Add New Partner"
          name="create-ttd-partner">New Partner
  </button>
  <button (click)="openNewAgencyDialog()"
          color="accent"
          mat-raised-button
          matTooltip="Add New Agency"
          name="create-ttd-partner">New Agency
  </button>
</div>

<mat-table [dataSource]="dataSource"
           id="table-ttd-partner-config"
           matSort
           matSortActive="partnerName"
           matSortDirection="asc">

  <ng-container matColumnDef="partnerName">
    <mat-header-cell *matHeaderCellDef mat-sort-header="partnerName">Partner Name</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.partnerName}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="partnerId">
    <mat-header-cell *matHeaderCellDef>Partner ID</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.partnerId}} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="group">
    <mat-header-cell *matHeaderCellDef>
      <div class="group group-header">
        <span *ngFor="let group of groups">{{group.name}}</span>
      </div>
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <div class="group">
        <span *ngFor="let group of groups">
          <mat-checkbox #groupItem
                        (change)="groupClick(group, element, groupItem.checked);groupItem.checked=!groupItem.checked"
                        [checked]="group.id === element.group?.id"
                        [value]="groups[0]">
          </mat-checkbox>
        </span>
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['partnerName', 'partnerId', 'group']; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let ttdBuyersDisplay; columns: ['partnerName', 'partnerId', 'group']"></mat-row>
</mat-table>

